import * as api from "./client";

export type ResearchAuditLogItem = {
  id: string;
  seq: number;
  entityType: string;
  entityId: string;
  action: "INSERT" | "UPDATE" | "DELETE";
  changedFields: Record<string, unknown> | null;
  actorId: string;
  actorEmail: string | null;
  actorType: "user" | "system";
  createdAt: string;
};

export type ResearchAuditLogFilters = {
  actorId?: string;
  actorEmail?: string;
  actorType?: "user" | "system";
  action?: string;
  entityType?: string;
  entityId?: string;
  from?: string;
  to?: string;
  limit?: number;
  cursor?: string;
};

export type ResearchAuditLogResponse = {
  auditLog: ResearchAuditLogItem[];
  pagination: {
    limit: number;
    nextCursor: string | null;
    hasMore: boolean;
  };
  requestId?: string;
};

function queryString(filters: ResearchAuditLogFilters): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== "") params.set(key, String(value));
  }
  const query = params.toString();
  return query ? `?${query}` : "";
}

export const researchAuditService = {
  list(filters: ResearchAuditLogFilters = {}): Promise<ResearchAuditLogResponse> {
    return api.get<ResearchAuditLogResponse>(`/v1/research/audit-log${queryString(filters)}`);
  },
};
